export class IMemberFreezeDetail {
    _id: string;
    daysLeft: number;
    freezeDate: string;
    status: string;
    isFreeze: boolean;
}